import { useTranslation } from "react-i18next";
import sepaLogo from "../../assets/images/SEPA-logo.png";
import swiftLogo from "../../assets/images/SWIFT-logo.png";
import { useDispatch, useSelector } from "react-redux";
import { removeBankWallet } from "../../store/actions/bankWalletsAction";
import Popup from "../common/Popup";
import Confirm from "../common/Confirm";
import { useState } from "react";
import { fetchDeleteWallet } from "../../pages/FetchDeleteWallet";

function BankWallet({ account }) {
  const userInfo = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [error, setError] = useState(false);
  const { t } = useTranslation();
  const deleteWallet = () => {
    fetchDeleteWallet(account.key, "bank").then((data) => {
      if (data.susscess) {
        dispatch(removeBankWallet(data.key));
      } else {
        setError(true);
      }
    });
  };
  const [isPopupOpenConfirmBank, setIsPopupOpenConfirmBank] = useState(false);
  const closePopupConfirmBank = () => {
    setIsPopupOpenConfirmBank(false);
  };

  const openPopupConfirmBank = () => {
    setIsPopupOpenConfirmBank(true);
  };
  return (
    <div className="wallet__item">
      <Popup isOpen={isPopupOpenConfirmBank} onClose={closePopupConfirmBank}>
        <Confirm
          confirm={deleteWallet}
          closePopup={closePopupConfirmBank}
          heading={t("Remove Bank Wallet")}
          description={t("Are you sure you want to remove this wallet?")}
          error={t("This wallet cannot be removed")}
          isError={error}
          yesText={t("Yes, delete it")}
          noText={t("Cancel")}
        />
      </Popup>
      <div className="grid-row-span-2 number-wallet">
        {account.type === "sepa" ? (
          <img src={sepaLogo} alt="logo SEPA" />
        ) : (
          <img src={swiftLogo} alt="logo SWIFT" />
        )}
      </div>
      <h4>{userInfo.fname + " " + userInfo.lname }</h4>
      <p className="grid-column-2 grid-row-2">
        {account.curr.toUpperCase()} {t("account ending in")}{" "}
        {account.iban.slice(-4)}
      </p>
      <div
        onClick={openPopupConfirmBank}
        className="grid-row-span-2 delete-wallet"
      >
        <i className="ri-close-large-line"></i>
      </div>
    </div>
  );
}

export default BankWallet;
